import { render, staticRenderFns } from "./OrderDraftItemExtras.vue?vue&type=template&id=a682df88&scoped=true&"
import script from "./OrderDraftItemExtras.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemExtras.vue?vue&type=script&lang=js&"
import style0 from "./OrderDraftItemExtras.vue?vue&type=style&index=0&id=a682df88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a682df88",
  null
  
)

export default component.exports